import axios from 'axios';
import { config } from '@biproxi/env';

const cancelSubscriptionMutation = async (subscriptionId: string) => {
  const res = await axios.post('/api/billing/cancel-subscription', { subscriptionId }, {
    headers: {
      Authorization: config.CHARGEBEE_KEY,
    },
  });
  const result = await res.data;
  return result;
};

export default cancelSubscriptionMutation;
